import api from '../core/api';
import VwStkDurumDTO from 'src/models/StokEczane/StokDurum/VwStkDurumDTO';
import VwStkDurumSearchDTO from 'src/models/StokEczane/StokDurum/VwStkDurumSearchDTO';
import VwStkAraDTO from 'src/models/StokEczane/StokDurum/VwStkAraDTO';
import VwStkUcrattarifeDTO from 'src/models/StokEczane/StokDurum/VwStkUcrattarifeDTO';
import VwStkGirisegoredepostokdurumDTO from 'src/models/StokEczane/StokDurum/VwStkGirisegoredepostokdurumDTO';
import VwStkDepodurumlistDTO from 'src/models/StokEczane/StokDurum/VwStkDepodurumlistDTO';
import VwStkGirisDepodurumlistDTO from 'src/models/StokEczane/StokDurum/VwStkGirisDepodurumlistDTO';
export class VwStokaraRequest //extends PaginateIstek
{
  islemTanimId?: number = null;
  barkodNo: string = null;
  islemAdi: string = '';
  stokKodu: string = '';
  mevcutlar?: boolean = true;
  depoDonemId: number = null;
  depoTanimId: number = null;
  orgId?: number = null;
  stokTipi?: number = 0;
}

export class StkUcretTarifaAra {
  depodonemId: number;
  depotanimId: number;
  ucrettarifetanimId: number;
}

const controllerName = 'StokDurum';

export const StokDurumApi = api.injectEndpoints({
  endpoints: (builder) => ({
    GetStokDurum: builder.mutation<VwStkDurumDTO[], VwStkDurumSearchDTO>({
      query: (req) => ({
        url: controllerName + '/GetStokDurumByQuery',
        method: 'POST',
        body: JSON.stringify(req)
      })
    }),
    getStokDurumList: builder.query<Array<VwStkDepodurumlistDTO>, VwStokaraRequest>({
      query: (req) => ({
        url: controllerName + '/GetStokAraByQuery',
        method: 'POST',
        body: JSON.stringify(req)
      }),
      providesTags: ["DepoStok"]
    }),
    GetStkUcretTarifeList: builder.query<VwStkUcrattarifeDTO[], StkUcretTarifaAra>({
      query: (req) => ({
        url: controllerName + '/GetStkUcretTarifeList',
        method: 'POST',
        body: JSON.stringify(req)
      })
    }),
    getStokGirisDurumList: builder.query<Array<VwStkGirisegoredepostokdurumDTO>, VwStokaraRequest>({
      query: (req) => ({
        url: controllerName + '/GetStokGirisDurumList',
        method: 'POST',
        body: JSON.stringify(req),
      }),
      // invalidatesTags: ["StokGirisDurumList"]
    }),
    girislereGoreDepoDurumGetir: builder.query<Array<VwStkGirisDepodurumlistDTO>, VwStokaraRequest>({
      query: (req) => ({
        url: controllerName + '/GirislereGoreDepoDurumGetir',
        method: 'POST',
        body: JSON.stringify(req),
      }),
    }),
    disTeminIlacGetir: builder.query<Array<VwStkDepodurumlistDTO>, {islemTanimId : number}>({
      query: (req) => ({
        url: controllerName + '/DisTeminIlacGetir',
        method: 'GET',
        params: req
      }),
    }),
  })
});

export const {
  useGetStokDurumMutation,
  useGetStokDurumListQuery,
  useLazyGetStokDurumListQuery,
  useLazyGetStkUcretTarifeListQuery,
  useLazyGetStokGirisDurumListQuery,
  useGirislereGoreDepoDurumGetirQuery,
  useLazyDisTeminIlacGetirQuery,
} = StokDurumApi;
